import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const prepareOrder = createAction("".concat(stateName, "/prepareOrder"));